import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import VenueDetails from '../../components/admincomponents/VenueDetails';

function ViewVenue({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <VenueDetails />            
    </>
  );
}

export default ViewVenue;
